/**
 * 常量
 *
*/


//抄表成功率-列表数据
export const SUCCESS_RATE = 'statistical/SUCCESS_RATE';

//断线排名-列表数据
export const BREAK_RANKS = 'statistical/BREAK_RANKS';

//通讯质量-列表数据
export const COMMUNICATION_QUALITY = 'statistical/COMMUNICATION_QUALITY';

//网关异常-列表数据
export const GATEWAY_NORMALS = 'statistical/GATEWAY_NORMALS';

//设备异常-列表数据
export const EQUIPMENT_NORMALS = 'statistical/EQUIPMENT_NORMALS';

//单个设备（网关或终端）异常-列表数据
export const DEVICE_NORMALS = 'statistical/DEVICE_NORMALS';



